@if (file4Reader && loaded) {
<div class="courrierView__reader">
  @if (!isEmailFile) {
  <div>
    @if (file4Reader && file4Reader?.extension) {
    <div>
      @if (file4Reader?.extension.toLowerCase() === 'pdf') {
      <span>
        @if (file4Reader) {
        <ngx-extended-pdf-viewer [src]="file4Reader.src" height="calc(100vh - 85px)" [zoom]="'auto'"
          [showFindButton]="true" [showPagingButtons]="true" [showZoomButtons]="true"
          [showPresentationModeButton]="true" [showOpenFileButton]="false" [showPrintButton]="false"
          [showDownloadButton]="false" [showSecondaryToolbarButton]="true" [showRotateButton]="true"
          [showHandToolButton]="true" [showScrollingButton]="true" [showSpreadButton]="false"
          [showPropertiesButton]="true" [customToolbar]="additionalButtons" [(page)]="currentPage"
          (pageRendered)="pageRendered($event)">
        </ngx-extended-pdf-viewer>
        }
        <ng-template #additionalButtons>
          <div id="toolbarViewer">
            <div id="toolbarViewerLeft">
              <pdf-toggle-sidebar></pdf-toggle-sidebar>
              <div class="toolbarButtonSpacer"></div>
              <pdf-find-button [showFindButton]="true" [textLayer]="true"></pdf-find-button>
              <pdf-paging-area></pdf-paging-area>
            </div>
            <div id="toolbarViewerRight">
              <pdf-presentation-mode></pdf-presentation-mode>
              <pdf-select-tool></pdf-select-tool>
              <pdf-rotate-page></pdf-rotate-page>
              <pdf-hand-tool></pdf-hand-tool>
              @if (file4Reader) {
              <button type="button" class="toolbarButton new-tab hiddenMediumView"
                [title]="'createCourrier.fileOCR' | translate" (click)="openOCR()">
                <img src="./assets/img/decoration/ocr.png" alt="" />
              </button>
              }
              <pdf-toggle-secondary-toolbar></pdf-toggle-secondary-toolbar>
            </div>
            <pdf-zoom-toolbar></pdf-zoom-toolbar>
          </div>
        </ng-template>
      </span>
      }
      @if (file4Reader?.extension.toLowerCase() === 'xlsx') {
      <span>
        @for (data of columnsExcel; track data; let index = $index) {
        <div>
          <h2 [ngClass]="{ 'mt-3': index > 0 }">{{ sheetNames[index] }}</h2>
          @if (columnsExcel && columnsExcel.length > 0 && excelData && excelData.length > 0) {
          <i-table [paginator]="true" class="super-table" [columns]="columnsExcel[index]" [items]="excelData[index]"
            id="excelforDatasFromExcelFile{{ index }}" [multiselect]="false" [height]="heightforExcelTable">
          </i-table>
          }
        </div>
        }
      </span>
      }
      @if (
      file4Reader?.extension.toLowerCase() !== 'rtf' &&
      file4Reader?.extension.toLowerCase() !== 'pdf' &&
      file4Reader?.extension.toLowerCase() !== 'txt' &&
      file4Reader?.extension.toLowerCase() !== 'xlsx' &&
      file4Reader?.extension.toLowerCase() !== 'docx'
      ) {
      <span>
        <i-viewer [file]="file4Reader"> </i-viewer>
      </span>
      }
      @if (
      file4Reader?.extension.toLowerCase() === 'rtf' ||
      file4Reader?.extension.toLowerCase() === 'txt' ||
      file4Reader?.extension.toLowerCase() === 'docx'
      ) {
      <span>
        <app-reader [currentFile]="cFile" [allowPrint]="false" [allowDownload]="false"></app-reader>
      </span>
      }
    </div>
    }
  </div>
  } @else {
  <i-accordion [hideShowAllBtn]="true">
    @if (convertedMail?.attachments?.length > 0) {
    <i-accordion-tab header="Fichiers joints" [showEditBtn]="false">
      @for (a of convertedMail?.attachments; track a; let i = $index) {
      <div class="file__info">
        <div class="file__container" [ngClass]="{ active: currentIndexFile === i }">
          <div class="file__forEvent link" (click)="download(a); currentIndexFile = i">
            @if (a?.extention.toLowerCase() === '.pdf') {
            <i class="bi--big_icon bi bi-filetype-pdf"></i>
            }
            @if (['.jpg','.png','.jpeg','.svg','.tif'].includes(a?.extention.toLowerCase())) {
            <i class="bi--big_icon bi bi-file-earmark-image-fill"></i>
            }
            @if (a?.extention.toLowerCase() === '.doc' || a?.extention.toLowerCase() === '.docx') {
            <i class="bi--big_icon bi bi-filetype-doc"></i>
            }
            @if (a?.extention.toLowerCase() === '.htm') {
            <i class="bi--big_icon bi bi-filetype-html"></i>
            }
            @if (a?.extention.toLowerCase() === '.odt') {
            <i class="iconODTFileSCSS"></i>
            }
            @if (a?.extention.toLowerCase() === '.xls' || a?.extention.toLowerCase() === '.xlsx') {
            <i class="bi--big_icon bi bi-filetype-xls"></i>
            }
            @if (a?.extention.toLowerCase() === '.xps') {
            <i class="bi--big_icon bi bi-filetype-xml"></i>
            }
            @if (a?.extention.toLowerCase() === '.txt') {
            <i class="bi--big_icon bi bi-filetype-txt"></i>
            }
            @if (a?.extention.toLowerCase() === '.rtf') {
            <i class="iconRTFFileSCSS--biggerIcon"></i>
            }
            @if (a?.extention.toLowerCase() === '.pptx' || a?.extention.toLowerCase() === '.ppt') {
            <i class="bi--big_icon bi bi-filetype-ppt"></i>
            }
            <div class="inline ms-3">
              <h3 class="file__title" pTooltip="{{ a?.filename }}" tooltipPosition="bottom">
                {{ a?.filename ? (a?.filename | maxLength: 30) : 'Pas de nom' }}
              </h3>
            </div>
          </div>
          <i class="bi bi-download me-3" (click)="download(a);"></i>
          <span class="file__index">{{ i + 1 }}</span>
        </div>
      </div>
      }
    </i-accordion-tab>
    }
    <i-accordion-tab header="Mail" [selected]="true" styleClass="h-100" [showEditBtn]="false">
      <div class="row">
        <div class="col-12 d-flex justify-content-start">
          <h4 class="custom-h4-title me-2 mb-0">{{ 'createCourrier.from' | translate }}:</h4>
          <div>{{ convertedMail?.sender.email }}</div>
        </div>
        <div class="col-12">
          <h4 class="custom-h4-title me-2 mb-0 d-inline">{{ 'createCourrier.to' | translate }}:</h4>
          @for (r of convertedMail.recipients; track r; let last = $last) {
          <div class="d-inline">{{ r?.email + (last ? '' : ', ') }}</div>
          }
        </div>
        <div class="col-12">
          <h4 class="custom-h4-title me-2 mb-0 d-inline">{{ 'date' | translate }}:</h4>
          <div class="d-inline">{{ convertedMail?.sentOnUtcDateTime | momentFormat: 'DD/MM/YYYY à HH:mm' }}</div>
        </div>
        <div class="col-12 d-flex justify-content-start">
          <h4 class="custom-h4-title me-2 mb-0">{{ 'object' | translate }}:</h4>
          <div>{{ convertedMail?.subject }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex justify-content-start h-100">
          <div class="iframe__container">
            <iframe id="file4ReaderIframe" [frameBorder]="0" [scrolling]="'no'" [srcdoc]="convertedMail?.bodyHtml"
              (load)="onIframeLoad()"></iframe>
          </div>
        </div>
      </div>
    </i-accordion-tab>
  </i-accordion>
  }
</div>
}
@if (showNotFound && file4Reader === null) {
<div class="nofound">
  <img src="./assets/img/decoration/nofiles.svg " class="img-fluid" width="600" alt="" />
</div>
}
@if (loaded === false) {
<div class="d-flex justify-content-center align-items-center">
  <img src="./assets/img/loupe-loader.gif " class="img-fluid" alt="" />
</div>
}

<p-dialog [(visible)]="showOCR" [modal]="true" appendTo="body" [style]="{ width: '50vw' }">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'createCourrier.documentOcr' | translate }}</h5>
      <div class="d-flex align-items-center">
        <i-button styleClass="blue me-3" [text]="'createCourrier.ocr' | translate" (click)="startOCR()"></i-button>
        @if (textToCopy !== null) {
        <i-button styleClass="red me-3" [text]="'reset' | translate" (click)="reset()"></i-button>
        }
      </div>
    </div>
  </p-header>
  @if (textToCopy) {
  <div class="alert alert-primary" [innerHtml]="textToCopy"></div>
  }
  <div class="d-flex align-items-center justify-content-center" style="overflow: auto">
    <i-button [text]="'createCourrier.zoom+' | translate" styleClass="blue me-3" (click)="zoomIn()"></i-button>
    <i-button [text]="'createCourrier.zoom-' | translate" styleClass="blue me-3" (click)="zoomOut()"></i-button>
    <i-button [text]="'createCourrier.resetZoom' | translate" styleClass="blue" (click)="resetImage()"></i-button>
  </div>
  <div #cropContainer style="display: block; max-height: 80vh; overflow: auto">
    @if (currentPageImageBase64) {
    <image-cropper [imageBase64]="currentPageImageBase64" [cropper]="cropperPosition" [maintainAspectRatio]="false"
      [cropperMinWidth]="1" [transform]="transform" [cropperMinHeight]="1" [imageQuality]="100" format="jpeg"
      (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady($event)"></image-cropper>
    }
  </div>
</p-dialog>